import React from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import { MagnifyGlass } from '../../../../../../static/icons/iconMagnifyingglass';
import { Typography } from '../../../../atoms/typography/Typography';
import { LinkButton } from '../../../../atoms/linkButton/LinkButton';

export const StyledSearchText = styled.span`
  &::after {
    content: '›';
    position: absolute;
    right: 4px;
  }
`;

const SearchInput = ({
  scrolled,
  handleInputChange,
  onBlur,
  results,
  open,
  query,
  t,
  large = false,
  handleSearchClick,
  locale,
}) => (
  <div className="relative flex items-center" onBlur={onBlur}>
    <div className="absolute right-4">
      <MagnifyGlass color={!scrolled ? 'white' : 'black'} />
    </div>
    <input
      onChange={handleInputChange}
      value={query}
      className={cx(
        'relative pl-4 pr-10 py-2 min-w-28 w-20 border focus:placeholder-opacity-60 rounded-full bg-transparent transition-width shadow-xl duration-300 ease-out md:focus:w-40 lg:focus:w-60 focus:outline-none',
        {
          'min-w-32 w-32': locale === 'de_DE',
          'border-black placeholder-black text-black': scrolled,
          'border-white placeholder-white text-white': !scrolled,
          '!bg-[rgba(255,255,255,.2)] w-full lg:focus:w-full': large,
        }
      )}
      placeholder={
        large ? t('common.searchBig') : t('common.search')?.toUpperCase()
      }
    />
    <div
      className={cx(
        'absolute top-12 min-w-[350px] max-h-[60vh] overflow-y-auto right-0 bg-white bg-opacity-90 shadow-lg rounded-md p-4 transform transition duration-300 ease-out origin-top-right',
        {
          'scale-100': open,
          'scale-0': !open,
          'w-full': large,
        }
      )}
    >
      {open ? (
        results.length > 0 ? (
          results.map((result, i) => (
            <LinkButton
              key={i}
              className="text-sm w-full font-medium text-customGray-900"
              variant="transparent"
              textAlign="left"
              title={result.name}
              href={result.url}
              onClick={() => handleSearchClick(result.name, result.url)}
            >
              <StyledSearchText
                title={result.text}
                className="relative max-w-[160px] pr-3 whitespace-nowrap text-ellipsis text-customGray-600 overflow-hidden"
              >
                {result.text}
              </StyledSearchText>
              {result.strongName ? <strong>{result.name}</strong> : result.name}
            </LinkButton>
          ))
        ) : (
          <Typography className="!text-sm text-customGray-500">
            {t('common.noResults')}
          </Typography>
        )
      ) : null}
    </div>
  </div>
);

export default SearchInput;
